import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    GET_PROJECT: createActionType(FULL_NAMESPACE, "GET_PROJECT"),
    GET_PROJECT_COMPLETED: createActionType(FULL_NAMESPACE, "GET_PROJECT_COMPLETED"),
    GET_PROJECT_SUMMARY_REPORTS: createActionType(FULL_NAMESPACE, "GET_PROJECT_SUMMARY_REPORTS"),
    GET_PROJECT_SUMMARY_REPORTS_COMPLETED: createActionType(FULL_NAMESPACE, "GET_PROJECT_SUMMARY_REPORTS_COMPLETED"),
    SET_TAB: createActionType(FULL_NAMESPACE, "SET_TAB")
};
